import axios from 'axios'
import store from '../store'

const CSRF_COOKIE_NAME = 'csrftoken'
const CSRF_HEADER_NAME = 'X-CSRFToken'

const session = axios.create({
  headers: {'Content-Type': 'application/json;charset=UTF-8'},
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
  baseURL: process.env.apiHost
})

session.interceptors.response.use(response => response, error => {
  const response = error.response
  store.dispatch('loading/end_loading')
  if (response.status === 500) {
    store.commit('errors/SHOW', {})
  }
  return Promise.reject(error)
})

export default session



// WEBPACK FOOTER //
// ./src/api/session.js